// BehaviorSection.js
import React from "react";
import { Box, Typography, Chip, Stack, Divider } from "@mui/material";
import { ThumbUp, ThumbDown } from "@mui/icons-material";
import BehaviorSectionSkeleton from "./BehaviorSectionSkeleton";

const BehaviorSection = ({ expected, unacceptable, loading }) => {
  if (loading) return <BehaviorSectionSkeleton />;

  return (
    <Box
      sx={{
        borderRadius: "4px",
        backgroundColor: "#001d3d",
        boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
        border: "1px solid rgba(255,255,255,0.12)",
        p: 3,
        mb: 4,
      }}
    >
      <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, color: "#fff", fontSize: "1.1rem" }}>
        House Rules
      </Typography>

      <Box sx={{ mt: 2 }}>
        <Stack direction="row" alignItems="center" spacing={1} mb={1}>
          <ThumbUp sx={{ color: "#fff" }} fontSize="small" />
          <Typography variant="subtitle1" sx={{ color: "rgba(255,255,255,0.9)", fontSize: "0.9rem" }}>Expected Behaviors</Typography>
        </Stack>
        <Stack direction="row" spacing={1} sx={{ flexWrap: "wrap", gap: 1 }}>
          {expected?.length > 0 ? (
            expected.map((behavior, index) => (
              <Chip
                key={index}
                label={behavior}
                size="small"
                sx={{
                  backgroundColor: "rgba(255,255,255,0.12)",
                  color: "#fff",
                  border: "1px solid rgba(255,255,255,0.3)",
                  fontSize: "0.8rem",
                }}
              />
            ))
          ) : (
            <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.7)", fontSize: "0.85rem" }}>No specific expectations</Typography>
          )}
        </Stack>
      </Box>

      <Divider sx={{ my: 3, borderColor: "rgba(255,255,255,0.2)" }} />

      <Box>
        <Stack direction="row" alignItems="center" spacing={1} mb={1}>
          <ThumbDown sx={{ color: "rgba(255,200,200,0.9)" }} fontSize="small" />
          <Typography variant="subtitle1" sx={{ color: "rgba(255,255,255,0.9)", fontSize: "0.9rem" }}>Unacceptable Behaviors</Typography>
        </Stack>
        <Stack direction="row" spacing={1} sx={{ flexWrap: "wrap", gap: 1 }}>
          {unacceptable?.length > 0 ? (
            unacceptable.map((behavior, index) => (
              <Chip
                key={index}
                label={behavior}
                size="small"
                sx={{
                  backgroundColor: "rgba(255,255,255,0.08)",
                  color: "rgba(255,220,220,0.95)",
                  border: "1px solid rgba(255,255,255,0.25)",
                  fontSize: "0.8rem",
                }}
              />
            ))
          ) : (
            <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.7)", fontSize: "0.85rem" }}>No specific restrictions</Typography>
          )}
        </Stack>
      </Box>
    </Box>
  );
};

export default BehaviorSection;
